import { Controller } from "stimulus";
import loader from "../assets/loader";
import translate from "../assets/translate";
/**
 * Zeigt ein VR-Panorama an
 * <div data-controller="panorama" data-panorama-src="/images/panotest.jpg"></div>
 *
 * Wenn nichts angegeben wird ist die Größe des Elements:
 *  width: 100%; // block-level Element
 *  height: 3/4 der Breite (wird per JS berechnet)
 *
 * Das Bild muss als equirectangular Panorama im Format 1:2 vorliegen.
 * Weitere Infos: https://photo-sphere-viewer.js.org/guide/config.html
 */

export default class extends Controller {
    initialize() {
        // Lazy-Loading Bild hinzufügen damit die "Fette" Bibliothek erst bei Bedarf geladen wird.
        const img = new Image();
        loader.show(null, this.element);
        this.ready = (new Promise(resolve => img.onload = resolve))
            .then(() => this.element.removeChild(img))
            .then(() =>
                import ( /* webpackChunkName: 'photo-sphere-viewer' */ '../assets/phote-sphere-viewer'))
            .then(({ default: Viewer }) => Viewer);
        this.ready.then(() => loader.hide(this.element));

        img.loading = "lazy";
        img.src = '/images/lazyload.gif';
        this.element.append(img);
    }

    connect() {
        this.ready.then(Viewer => this.render(Viewer));
    }

    disconnect() {
        if (this.viewer) {
            this.viewer.destroy();
        }
    }

    render(Viewer) {
        if (this.element.offsetHeight <= 1) {
            // Das Element muss eine Höhe haben, damit der Viewer korrekt arbeitet
            this.element.style.height = (this.element.offsetWidth / 4 * 3).toFixed(1) + "px";
        }
        this.viewer = new Viewer({
            container: this.element,
            panorama: this.data.get('src'),
            navbar: (this.data.get('navbar') === null || this.data.get('navbar')) ? ['autorotate', 'zoom', 'fullscreen'] : false,
            touchmoveTwoFingers: this.data.get('touchmove-two-fingers') === null || this.data.get('touchmove-two-fingers'),
            defaultZoomLvl: parseInt(this.data.get('zoom') || 50),
          lang: {
            'twoFingers': translate('tpWeb.global.panorama.twofingers.label'),
            'autorotate': translate('tpWeb.global.panorama.autorotate.label'),
            'zoom': translate('tpWeb.global.panorama.zoom.label'),
            'zoomOut': translate('tpWeb.global.panorama.zoomout.label'),
            'zoomIn': translate('tpWeb.global.panorama.zoomin.label'),
            'move': translate('tpWeb.global.panorama.move.label'),
            'download': translate('tpWeb.global.panorama.download.label'),
            'fullscreen': translate('tpWeb.global.panorama.fullscreen.label'),
            'menu': translate('tpWeb.global.panorama.menu.label'),
            'ctrlZoom': translate('tpWeb.global.panorama.ctrlzoom.label'),
            'loadError': translate('tpWeb.global.panorama.loaderror.label')
          }
        });
        this.viewer.startAutorotate();
        // this.viewer
        //     .on('position-updated', (e, position) => {
        //         console.log(`new position is longitude: ${position.longitude} latitude: ${position.latitude}`);
        //     })
        //     .on('zoom-updated', (e, level) => {
        //         console.log(`zoom level: ${level}`)
        //     })
        //     .on('ready', (e) => {
        //         console.log("READY", e);
        //     })
    }
}
